import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const NotLoggedIn = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "80vh",
        backgroundColor: "#F8F9E9",
        padding: 4,
        borderRadius: 4,
        boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
        margin: 4,
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        style={{ textAlign: "center" }}
      >
        <Typography
          variant="h3"
          sx={{ fontWeight: "bold", color: "#2A289C", mb: 2 }}
        >
          Oh no!
        </Typography>

        <Typography
          variant="h6"
          sx={{ color: "#57511F", mb: 1 }}
        >
          You are not yet logged in.
        </Typography>

        <Typography
          variant="subtitle1"
          sx={{ color: "#57511F", mb: 4 }}
        >
          Login to continue.
        </Typography>

        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Button
            variant="contained"
            onClick={() => { navigate("/login"); window.scrollTo(0, 0); }}
            style={{ 
              backgroundColor: "green", 
              color: "white", 
              borderRadius: '999px'
            }}
          >
            Login
          </Button>
       
        </motion.div>
      </motion.div>
    </Box>
  );
};

export default NotLoggedIn;
